export default __webpack_public_path__ + "static/media/manipad.e5796ce1.jpg";